import {GetAuditsRequest} from "@/Stub/V1";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {AuditsApiClient} from "@/Service/Api/V1/ApiClients/AuditsApiClient";

export type useGetAuditsParams = {
    requestParams?: GetAuditsRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetAudits = ({ requestParams, enabled, savePreviousData }: useGetAuditsParams = {}) => useQuery({
    ...QueryKeys.audits.list(requestParams),
    queryFn: async () => await AuditsApiClient.getAudits(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});